import { ConditionContext } from "hooks/ConditionContext";
import React, { useContext } from "react";
import { sideNav } from "utils/constant";
import ChatSection from "./ChatSection";
import NotesSection from "./NotesSection";
import AskQuestionSection from "./AskQuestionSection";
import AboutSection from "./AboutSection";
import JobDescription from "./JobDescription";
import Modal from "react-bootstrap/Modal";
import useIsMobile from "hooks/useIsMobile";
import { injectDrawerStyles } from "./drawerStyles";
import VideoEffectsPanel from "components/room/VideoEffectsPanel";

injectDrawerStyles();

// Module-level component — stable function reference across parent re-renders.
// Previously defined inside Index, causing React to unmount/remount on every
// RoomLayout timer tick and destroy AskQuestionSection's currentPage state.
const DrawerContent = ({ activeSection }) => (
  <>
    {activeSection === sideNav.Chat && <ChatSection />}
    {activeSection === sideNav.Notes && <NotesSection />}
    {activeSection === sideNav.QA && <AskQuestionSection />}
    {activeSection === sideNav.JobDescription && <JobDescription />}
    {activeSection === sideNav.About && <AboutSection />}
    {activeSection === sideNav.Effects && <VideoEffectsPanel />}
  </>
);

const Index = () => {
  const { setOpenedComponentDrawer, openedComponentDrawer } =
    useContext(ConditionContext);
  const isMobile = useIsMobile();

  if (openedComponentDrawer.length === 0) return null;

  if (isMobile) {
    return (
      <Modal
        show
        centered
        onHide={() => setOpenedComponentDrawer("")}
        dialogClassName="dw-mobile-modal"
      >
        <Modal.Body>
          <div style={{ height: "550px", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <DrawerContent activeSection={openedComponentDrawer} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="dw-close-btn" onClick={() => setOpenedComponentDrawer("")}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <div className="drawer-section">
      <DrawerContent activeSection={openedComponentDrawer} />
    </div>
  );
};

export default Index;